export { UpdateAvatar } from "./update-avatar";
